
export enum UserRoleEnum {
    OrganisationAdmin = "COMPANY_ADMIN",
    OrganisationViewer = "COMPANY_VIEWER",
    Admin = "ADMIN",
    SuperAdmin = "SUPER_ADMIN",
    AgencyAdmin = "AGENCY_ADMIN",
    AgencyUser = "AGENCY_USER",
}
